<template>
  <el-dialog :visible.sync="dialogVisible" width="900px" height="80%" :before-close="handleClose">
    <div class="manual">
     <p class="title">1：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p1') }}</p>
     <p class="title">2：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p2') }}</p>
     <div>
       <p class="title">3：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p3') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p301') }} </p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p302') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p303') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p304') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p305') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p306') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p307') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p308') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p309') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p310') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p311') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p312') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p313') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p314') }}</p>
     </div>
     <div>
       <p class="title">4：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p4') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p41') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p42') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p43') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p44') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p45') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p46') }}</p>
     </div>
     <div>
       <p class="title">5：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p5') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p51') }}</p>
       <p>{{ $t('BusinessPurchaseForecast.forecastUserManualData.p52') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p53') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p54') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p55') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p56') }}</p>
     </div>
     <div>
       <p class="title">6：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p6') }}</p>
       <p>6.1：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p601') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p602') }}</p>
       <p class="formula p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p603') }}</p>
       <p class="formula p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p604') }}</p>
       <p class="formula p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p605') }}</p>
       <p class="formula p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p606') }}</p>
       <p>6.2：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p607') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p608') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p609') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p610') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p611') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p612') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p613') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p614') }}</p>
       <p>6.3：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p616') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p617') }}</p>
       <p>6.4：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p618') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p619') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p620') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p621') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p622') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p623') }}</p>
       <p>6.5：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p624') }}</p>
       <p class="p3">{{ $t('BusinessPurchaseForecast.forecastUserManualData.p625') }}</p>
       <p class="p3">i:{{ $t('BusinessPurchaseForecast.forecastUserManualData.p626') }}</p>
       <p class="p3">ii:{{ $t('BusinessPurchaseForecast.forecastUserManualData.p627') }}</p>
       <p class="p3">iii：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p628') }}</p>
       <p>6.6：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p629') }}</p>
       <p class="p3">i：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p630') }}</p>
       <p class="p3">ii：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p631') }}</p>
       <p class="p3">iii：{{ $t('BusinessPurchaseForecast.forecastUserManualData.p632') }}</p>
     </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    show() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
  .manual {
    .title {
      text-indent: 0em;
    }
    .formula {
        color: #8f8f9d;
        margin:0;
    }
    p {
      text-indent: 2em;
      line-height: 18px;
    }
    .p3{
      text-indent: 4em;
    }
  }
</style>
